import { spaces } from '@kimuno/theme';
import { Box } from '@mui/material';
import { type Editor, useEditorState } from '@tiptap/react';
import type React from 'react';
import { useEffect, useState } from 'react';

import { useTextMenuCommands } from '../../../utils/tipTapEditor/useTextMenuCommands';
import LinkEditorPanel from './LinkEditorPanel';
import LinkPreviewPanel from './LinkPreviewPanel';

interface LinkMenuProps {
	editor: Editor;
	initialShowEdit?: boolean;
}

const LinkMenu: React.FC<LinkMenuProps> = (props) => {
	const { editor, initialShowEdit = false } = props;
	const [showEdit, setShowEdit] = useState(initialShowEdit);

	const { onSetLink, onUnsetLink } = useTextMenuCommands(editor);

	const { link } = useEditorState({
		editor,
		selector: (ctx) => {
			const attrs = ctx.editor.getAttributes('link');
			return { link: attrs.href, target: attrs.target };
		},
	});

	const handleEdit = () => {
		setShowEdit(true);
	};

	const handleUnsetLink = () => {
		onUnsetLink();
		setShowEdit(false);
	};

	const handleSubmit = ({ url }: { url: string }) => {
		onSetLink({ url });
		setShowEdit(false);
	};

	useEffect(() => {
		const handleSelectionChange = () => {
			setShowEdit(false);
		};

		editor.on('selectionUpdate', handleSelectionChange);

		return () => {
			editor.off('selectionUpdate', handleSelectionChange);
		};
	}, [editor]);

	return (
		<Box sx={{ padding: spaces.xxs }}>
			{showEdit ? (
				<LinkEditorPanel initialUrl={link} onSubmit={handleSubmit} />
			) : (
				<LinkPreviewPanel url={link} onClear={handleUnsetLink} onEdit={handleEdit} />
			)}
		</Box>
	);
};

export default LinkMenu;
